import React from 'react';

const TrialMatchList = () => {
  const trials = [
    {
      id: "NCT04532723",
      match: 94,
      name: "Phase II IO/TKI Combination",
      location: "Memorial Sloan",
      status: "Recruiting",
      distance: 12
    },
    {
      id: "NCT04256941",
      match: 87,
      name: "Checkpoint + RT",
      location: "Mayo Clinic",
      status: "Recruiting",
      distance: 45
    },
    {
      id: "NCT04827576",
      match: 81,
      name: "Oral Therapy Maintenance",
      location: "Virtual/Home-based",
      status: "Recruiting",
      distance: 0
    }
  ];
  
  return (
    <div className="bg-white rounded-lg shadow mb-4">
      <div className="p-4 border-b">
        <h3 className="text-lg font-medium">Matching Trials:</h3>
      </div>
      
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Match</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Trial</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Location/Status</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {trials.map((trial) => (
            <tr key={trial.id} className="hover:bg-gray-50 cursor-pointer">
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`font-medium ${trial.match > 90 ? 'text-red-500' : 'text-orange-500'}`}>
                  {trial.match}%
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="font-medium text-gray-900">{trial.id}</div>
                <div className="text-gray-500">{trial.name}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex flex-col">
                  <span>{trial.location}</span>
                  <span className="text-green-500">{trial.status}</span>
                  <span className="text-gray-500">{trial.distance} miles</span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TrialMatchList;